

import React from "react";
import { FaCode, FaWifi, FaRobot, FaGraduationCap } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ServiceSection = () => {
    const serviceData = [
  {
    title: "IT Services & Development",
    subtitle: "Web & App Development, APIs, ERP, Custom Software",
    icon: <FaCode />,
    items: [
      "Web & Mobile Applications",
      "API Development",
      "ERP Solutions",
      "Custom Software Development",
    ],
    path: "/services",
  },
  {
    title: "IoT Training & Solutions",
    subtitle: "Smart devices, sensors, automation, hands-on workshops",
    icon: <FaWifi />,
    items: [
      "Smart Device Development",
      "Sensor Integration",
      "Automation Systems",
      "Hands-on Workshops",
    ],
    path: "/programs",
  },
  {
    title: "Robotics Lab & Courses",
    subtitle: "Robotic kits, curriculum, school/college setup support",
    icon: <FaRobot />,
    items: [
      "Robotic Kit Development",
      "Curriculum Design",
      "Lab Setup Support",
      "Educational Programs",
    ],
    path: "/robotic-lab",
  },
  {
    title: "IT Training Programs",
    subtitle: "Fullstack, Python, AI, Web, and Corporate Upskilling",
    icon: <FaGraduationCap />,
    items: [
      "Fullstack Development",
      "Python Programming",
      "AI & Machine Learning",
      "Corporate Training",
    ],
    path: "/programs",
  },
];
  const navigate = useNavigate();
  return (
     <div className="container py-5">
   <div className="row">
         <div className="section__title mb-4 text-center">
           <span className="sub-title">Services</span>
           <h2 className="title">Services Designed to Drive Your Success</h2>
           <p className="desc">             Smart, Scalable Solutions for Every Stage of Growth
           </p>
         </div>

         {serviceData.map((service, index) => (
           <div className="col-md-6 mb-4" key={index}>
             <div className="card h-100 shadow-sm">
               <div className="card-body d-flex flex-column">
                 <div className="mb-3 text-primary fs-2">{service.icon}</div>
                 <h5 className="fw-bold fs-5">{service.title}</h5>
               <p className="text-muted fs-6">{service.subtitle}</p>
               <ul className="list-unstyled fs-6">
                 {service.items.map((item, i) => (
                    <li key={i} className="mb-1">
                     <span className="text-primary">•</span> {item}
                   </li>
                 ))}
                </ul>

               <div className="mt-auto">
                 <button
                  className="btn btn-outline-primary w-100 rounded fw-semibold"
                   onClick={() => navigate(service.path)}
                 >
                     Learn More →
                 </button>
               </div>
             </div>
           </div>
          </div>
       ))}
      </div>
    </div>
  )
}

export default ServiceSection
